import React from 'react'
import UniFundRaising from '../Components/UniFundRaising/UniFundRaising'

const FundRaising = () => {
  return (
    <div>
      <UniFundRaising/>
    </div>
  )
}

export default FundRaising
